import { EColors } from '@rfc/rfc-components-library/types'

export type NotificationState = {
    type: EColors
    message: string
}

export enum ENotificationActions {
    CLEAR = 'clear',
    ERROR = EColors.ERROR,
    INFO = EColors.INFO,
    LIGHT = EColors.LIGHT,
    PRIMARY = EColors.PRIMARY,
    SUCCESS = EColors.SUCCESS,
    WARNING = EColors.WARNING,
    QUEUE_ITEM = 'queueItem'
}

export enum ENotificationMutations {
    CLEAR = 'clear',
    ERROR = EColors.ERROR,
    INFO = EColors.INFO,
    LIGHT = EColors.LIGHT,
    PRIMARY = EColors.PRIMARY,
    SUCCESS = EColors.SUCCESS,
    WARNING = EColors.WARNING,
    ADD_TO_QUEUE = 'addToQueue',
    REMOVE_FROM_QUEUE = 'removeFromQueue'
}
